/**
 * Utility functions for parsing and creating clickable links in messages
 */

export const parseMessageLinks = (messageText) => {
    if (!messageText || typeof messageText !== 'string') {
        return [{ type: 'text', content: messageText }];
    }

    const parts = [];
    let lastIndex = 0;

    const patterns = [
        {
            regex: /(crane\s+#(\d+)|ticket\s+#(\d+))/gi,
            type: 'entity',
            entityType: (match) => match.toLowerCase().startsWith('crane') ? 'crane' : 'ticket',
            id: (match) => {
                const craneMatch = match.match(/crane\s+#(\d+)/i);
                const ticketMatch = match.match(/ticket\s+#(\d+)/i);
                return craneMatch ? craneMatch[1] : ticketMatch[1];
            }
        }
    ];

    const allMatches = [];

    patterns.forEach(pattern => {
        let match;
        while ((match = pattern.regex.exec(messageText)) !== null) {
            allMatches.push({
                ...match,
                pattern,
                start: match.index,
                end: match.index + match[0].length
            });
        }
    });

    allMatches.sort((a, b) => a.start - b.start);

    for (const match of allMatches) {
        if (match.start < lastIndex) {
            continue;
        }

        if (match.start > lastIndex) {
            const textContent = messageText.slice(lastIndex, match.start);
            if (textContent) {
                parts.push({ type: 'text', content: textContent });
            }
        }

        const entityType = match.pattern.entityType(match[0]);
        const entityId = match.pattern.id(match[0]);

        parts.push({
            type: 'link',
            content: match[0],
            entityType,
            entityId,
            fullMatch: match[0]
        });

        lastIndex = match.end;
    }

    if (lastIndex < messageText.length) {
        const textContent = messageText.slice(lastIndex);
        if (textContent) {
            parts.push({ type: 'text', content: textContent });
        }
    }

    if (parts.length === 0) {
        return [{ type: 'text', content: messageText }];
    }

    return parts;
};

export const navigateToEntity = (entityType, entityId) => {
    if (!entityType || !entityId) {
        return;
    }

    const basePath = entityType === 'crane' ? 'ecrane' : 'ticket';

    const url = `/${basePath}/edit/${entityId}`;
    window.location.href = url;
};
